import React from 'react';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

const commonStyles = 'pl-4 border-r-2 border-white font-semibold h-12';

interface CellInfo {
  renderValue: () => React.ReactNode;
  getValue: () => string | number;
}

export interface GoalCriticalElementsColumn {
  id: string;
  accessorKey: string;
  header: () => React.JSX.Element;
  cell: (info: CellInfo) => React.JSX.Element;
  headerClassName: string;
  className: string;
  enableSorting: boolean;
  isHeaderCentered?: boolean;
}

export const getGoalCriticalElementsTableSettings = (
  handleViewDetails: (id: string | number) => void
): GoalCriticalElementsColumn[] => [
  {
    id: 'summary',
    accessorKey: 'summary',
    header: () => <span>CRITICAL ELEMENT</span>,
    cell: (info) => <span>{info.renderValue()}</span>,
    headerClassName: `${commonStyles} rounded-tl-md rounded-bl-md`,
    className: 'pl-4 py-3 tablet:w-[75%] font-semibold',
    enableSorting: false,
  },
  {
    id: 'actions',
    accessorKey: 'id',
    header: () => <span>ACTION</span>,
    isHeaderCentered: true,
    cell: (info) => (
      <div className="flex justify-center">
        <Button
          variant="reserve-outlined"
          size="sm"
          iconBefore={<Icons.Eye aria-label="EyeIcon" />}
          className="text-xs md:text-sm"
          onClick={() => handleViewDetails(info.getValue())}
        >
          View Details
        </Button>
      </div>
    ),
    headerClassName: `${commonStyles} rounded-tr-md rounded-br-md`,
    className: 'pl-4 py-3 tablet:w-[20%]',
    enableSorting: false,
  },
];
